module.exports = __webpack_public_path__ + "static/businessPartnerIcon-ffb86210962e06670576c69ec9b0a224.svg";